import { homeContent } from "../data/mockHome";

export function SectorsPage() {
  return (
    <div className="bg-slate-950 py-24">
      <div className="mx-auto max-w-6xl px-6">
        <header className="max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-emerald-300">
            Sectors
          </p>
          <h1 className="mt-4 text-4xl font-semibold text-white">
            We design for teams where failure isn’t an option.
          </h1>
          <p className="mt-4 text-slate-300">
            AVUX brings UX, AI, and operations together across public safety, healthcare, compliance, and AI-first products.
          </p>
        </header>
        <div className="mt-16 grid gap-6 md:grid-cols-2">
          {homeContent.sectors.map((sector) => (
            <article
              key={sector.name}
              className="overflow-hidden rounded-3xl border border-white/10 bg-slate-900/60"
            >
              <img
                src={sector.image}
                alt={`${sector.name} outcome`}
                className="h-56 w-full object-cover"
              />
              <div className="space-y-3 px-8 py-8">
                <h2 className="text-2xl font-semibold text-white">{sector.name}</h2>
                <p className="text-sm text-slate-300">{sector.outcome}</p>
                <button className="text-sm font-medium text-emerald-300 hover:text-emerald-200">
                  Explore sector →
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
